import fetch from "auth/FetchInterceptor";

export const EnumService = {};

EnumService.getDiscountType = async () => {
  let apiUrl = "/v1/discount/type";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EnumService.getTrxType = async () => {
  let apiUrl = "/v1/trx/type";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EnumService.getTicketType = async () => {
  let apiUrl = "/v1/ticket/type";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EnumService.getImportType = async () => {
  let apiUrl = "/v1/import/type";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EnumService.getProductType = async () => {
  let apiUrl = "/v1/product/type";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EnumService.getReportType = async () => {
  let apiUrl = "/v1/report/type";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

export default EnumService;
